import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ShipmentDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  shipmentDetails: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async loadDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`shipments/${payload.id}/details`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  shipmentDetails: state => state.shipmentDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
